<template>
  <Flex column grow bg-gray-100>
    <Banner :alert="alert" @close="onBannerClose" />
    <Flex v-if="lookupData.id" column pt-3 bg-gray-100>
      <LookupTranslator :lookup-data="lookupData" :available-languages="availableLanguages" />
      <Flex justify-center pb-3 v-if="!inIframe">
        <Button v-on:click="translate" :disabled="translating">Translate</Button>
      </Flex>
    </Flex>
  </Flex>
</template>

<script>
import Button from '@wizer/core/components/button/Button.vue'
import Flex from '@wizer/core/components/flex/Flex.vue'
import LookupTranslator from '../components/i18n/LookupTranslator.vue'
import LookupService from '../services/LookupService'
import DynamicPublisherService from '../services/DynamicPublisherService'
import IframeMixin from '../mixins/IframeMixin'
import Banner from '../components/Banner'

export default {
  name: 'i18nlookup',
  mixins: [IframeMixin],

  components: {
    Banner,
    Button,
    Flex,
    LookupTranslator,
  },

  data() {
    return {
      lookupData: Object,
      translating: false,
      alert: null,
      containsError: Boolean,
      availableLanguages: [],
      selectedLanguage: '',
    }
  },

  computed: {
    inIframe() {
      try {
        return window.self !== window.top
      } catch (e) {
        return true
      }
    },
  },

  mounted() {
    this.loadData()
    this.registerProcessCallback(this.translate)
  },

  beforeRouteUpdate(to, from, next) {
    this.loadData()
    next()
  },

  methods: {
    async loadData() {
      try {
        const lookupResponse = await LookupService.get(this.$route.params.id)
        this.lookupData = lookupResponse.data
        this.availableLanguages = LookupService.getLanguageSelectValues(this.lookupData)
        this.selectedLanguage = this.availableLanguages[0].id
      } catch (error) {
        this.containsError = true
        this.alert = { type: 'error', message: error.response.data }
      } finally {
        await this.checkDynamicPublisher()
        window.parent.postMessage(
          {
            status: 'vue-loaded',
          },
          window.location.origin,
        )
      }
    },
    async checkDynamicPublisher() {
      const isInProgress = (await DynamicPublisherService.getIsInProgress()).data.isInProgress
      if (isInProgress) {
        this.alert = {
          type: 'info',
          message: 'Dynamic Publisher is currently running. Displayed data might be out of date.',
          duration: 3000,
        }
      }
    },
    async translate() {
      // We do not want to submit any values for translating if the form has error,
      // or if request was unsuccessful
      if (this.containsError === 'error' || !this.lookupData || !this.lookupData.translations) {
        window.parent.postMessage(
          {
            status: 'vue-success',
          },
          window.location.origin,
        )
        return
      }
      const data = {
        id: this.lookupData.id,
        translations: this.lookupData.translations.slice(1),
      }

      try {
        this.translating = true
        await LookupService.post(data)
        this.alert = {
          type: 'success',
          message: 'Translated',
          duration: 3000,
        }
        this.containsError = false
        window.parent.postMessage(
          {
            status: 'vue-success',
          },
          window.location.origin,
        )
      } finally {
        this.translating = false
      }
    },
    onBannerClose() {
      this.alert = null
    },
  },
}
</script>

<style>
.w-button[disabled='disabled'],
.w-button:disabled {
  @apply bg-gray-500;
}
</style>
